export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvAvatar.vue?vue&type=template&id=1f769c79&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvAvatar.vue?vue&type=template&id=1f769c79&lang=pug&
// module id = 171
// module chunks = 0 1